import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ContractCreateFeModel, IContractEditState } from './edit.reducer'
import { StoreKeysEnum } from '../../../../../store/store-keys'
import cloneDeep from 'lodash/cloneDeep'
import { Drupoz } from '../../../../../api/backend'
import { toDisplayUnits } from '../../../../../shared/utils/month-year-unit'

export const selectContractEditFeature = createFeatureSelector<Readonly<IContractEditState>>(StoreKeysEnum.ContractCreateFeature)

export const selectContractEditContract = createSelector(
    selectContractEditFeature,
    (feature): ContractCreateFeModel => (feature?.contract),
)
export const selectContractEditContractAndDrupozs = createSelector(
    selectContractEditFeature,
    (feature): {contract: ContractCreateFeModel; drupozs: Drupoz[]} => ({ contract: feature?.contract, drupozs: feature?.drupozs }),
)
export const selectContractEditContractId = createSelector(
    selectContractEditContract,
    contract => (contract?.id),
)
export const selectContractEditPayoutToId = createSelector(
    selectContractEditContract,
    contract => (contract?.payoutToId),
)
export const selectContractEditGroupId = createSelector(
    selectContractEditContract,
    contract => (contract?.groupId),
)
export const selectContractEditContractOwnerIds = createSelector(
    selectContractEditContract,
    contract => (contract?.ownerIds),
)
export const selectContractEditContractTenantIds = createSelector(
    selectContractEditContract,
    contract => (contract?.tenantIds),
)
export const selectContractEditContractParcelIds = createSelector(
    selectContractEditContract,
    contract => (contract?.parcelIds),
)
export const selectContractEditContractCpds = createSelector(
    selectContractEditContract,
    contract => (contract?.cpds),
)
export const selectContractEditContractIndefinite = createSelector(
    selectContractEditContract,
    contract => (contract?.indefinite),
)
export const selectContractEditContractContractParamTemplate = createSelector(
    selectContractEditContract,
    contract => (contract?.contractParamTemplate),
)
export const selectContractEditContractParamTemplate = createSelector(
    selectContractEditContract,
    contract => (contract?.paramTemplate),
)
export const selectContractEditContractAppendixSourceId = createSelector(
    selectContractEditContract,
    contract => (contract?.appendixSourceId),
)
export const selectContractEditContractSuccessiveSourceId = createSelector(
    selectContractEditContract,
    contract => (contract?.successiveSourceId),
)
export const selectContractEditContractSignatureDate = createSelector(
    selectContractEditContract,
    contract => (contract?.signatureDate),
)
export const selectContractEditContractReusedPreviousExpiration = createSelector(
    selectContractEditContract,
    contract => (contract?.reusedPreviousExpiration),
)
export const selectContractEditContractOwnerParams = createSelector(
    selectContractEditContract,
    contract => (contract?.ownerparams ?? []),
)
export const selectContractEditPaymentsFromEconomicYear = createSelector(
    selectContractEditContract,
    contract => (contract?.paymentsFromEconomicYear),
)
export const selectContractEditNote = createSelector(
    selectContractEditContract,
    contract => (contract?.note),
)
export const selectContractEditContractCreateIndividualDocuments = createSelector(
    selectContractEditContract,
    contract => (contract?.createIndividualDocuments),
)
export const selectContractEditContractRentType = createSelector(
    selectContractEditContract,
    contract => (contract?.rentType),
)
export const selectContractEditCounterpartyNumber = createSelector(
    selectContractEditContract,
    contract => (contract?.counterpartyNumber),
)
export const selectContractEditExpirationDate = createSelector(
    selectContractEditContract,
    contract => (contract?.expirationDate),
)
export const selectContractEditContractVersionType = createSelector(
    selectContractEditContract,
    contract => (contract?.versionType),
)
export const selectContractEditContractFurtherRentPossible = createSelector(
    selectContractEditContract,
    contract => (contract?.furtherRentPossible),
)
export const selectContractEditContractReqNewAppendixAfterReprice = createSelector(
    selectContractEditContract,
    contract => (contract?.reqNewAppendixAfterReprice),
)
export const selectContractEditContractTenantHasPreemption = createSelector(
    selectContractEditContract,
    contract => (contract?.tenantHasPreemption),
)
export const selectContractEditContractToEconomicYear = createSelector(
    selectContractEditContract,
    contract => (contract?.toEconomicYear),
)
export const selectContractEditIsNotSet = createSelector(
    selectContractEditContract,
    contract => (!contract || contract?.ownerIds?.length === 0 || contract?.tenantIds?.length === 0),
)
// ==> State
export const selectContractEdiSelectedTab = createSelector(
    selectContractEditFeature,
    feature => (feature?.selectedTab),
)
export const selectContractEditEditedCpd = createSelector(
    selectContractEditFeature,
    feature => (feature?.editedCPD),
)
export const selectContractEditEditedOwnerships = createSelector(
    selectContractEditFeature,
    feature => (feature?.editedOwnerships),
)
export const selectContractEditEditedParcel = createSelector(
    selectContractEditFeature,
    feature => (feature?.editedParcel),
)
export const selectContractEditSuccessiveSubjects = createSelector(
    selectContractEditFeature,
    feature => (feature?.successiveSubjects),
)
export const selectContractEditSelectableSuccessiveSubjects = createSelector(
    selectContractEditFeature,
    feature => (feature?.selectableSuccessiveSubjects),
)
export const selectContractEditParcels = createSelector(
    selectContractEditFeature,
    feature => cloneDeep(feature?.parcels),
)
export const selectContractEditIsLoading = createSelector(
    selectContractEditFeature,
    feature => (feature?.isLoading),
)
export const selectContractEditIsEditingContract = createSelector(
    selectContractEditFeature,
    feature => (feature?.isEditingContract),
)
export const selectContractEditEditSessionKey = createSelector(
    selectContractEditFeature,
    feature => (feature?.editSessionKey),
)
export const selectContractEditSameLVAndKatuze = createSelector(
    selectContractEditFeature,
    feature => (feature?.sameLVAndKatuze),
)
export const selectContractEditIsEdit = createSelector(
    selectContractEditFeature,
    feature => (feature?.isEdit),
)
export const selectContractEditContractRentDrupozCollection = createSelector(
    selectContractEditFeature,
    feature => (feature?.contractRentDrupozCollection),
)
export const selectContractEditContractRentUnknownCollection = createSelector(
    selectContractEditFeature,
    feature => (feature?.contractRentUnknownCollection),
)
export const selectContractEditIsAppendix = createSelector(
    selectContractEditFeature,
    feature => (feature?.isAppendix),
)
export const selectContractEditIsSuccessive = createSelector(
    selectContractEditFeature,
    feature => (feature?.isSuccessive),
)
export const selectContractEditIsFormActive = createSelector(
    selectContractEditFeature,
    feature => (feature?.isFormActive),
)
export const selectContractEditIsRentTypeDefined = createSelector(
    selectContractEditFeature,
    feature => (feature?.isRentTypeDefined),
)
export const selectContractEditParamTemplates = createSelector(
    selectContractEditFeature,
    feature => (feature?.contractParamTemplates),
)
export const selectContractEditSignatureYear = createSelector(
    selectContractEditFeature,
    feature => (feature?.signatureYear),
)
export const selectContractEditSignatureDocuments = createSelector(
    selectContractEditFeature,
    feature => (feature?.signatureDocuments),
)
export const selectContractEditSignatureDocumentsGroup = createSelector(
    selectContractEditFeature,
    feature => (feature?.signatureDocumentsGroup),
)
export const selectContractEditTotalAcreage = createSelector(
    selectContractEditFeature,
    feature => (feature?.totalAcreage),
)
export const selectContractEditParcelsOrder = createSelector(
    selectContractEditFeature,
    feature => (feature?.parcelsOrder),
)
export const selectContractEditPreviousSubjectSignDates = createSelector(
    selectContractEditFeature,
    feature => (feature?.previousSubjectSignDates),
)
export const selectContractEditOwners = createSelector(
    selectContractEditFeature,
    feature => (feature?.owners),
)
export const selectContractEditOwnersLength = createSelector(
    selectContractEditFeature,
    feature => (feature.owners?.length),
)
export const selectContractEditTenants = createSelector(
    selectContractEditFeature,
    feature => (feature?.tenants),
)
export const selectContractEditSelectedContractTemplate = createSelector(
    selectContractEditFeature,
    feature => (feature?.selectedContractTemplate),
)
export const selectContractEditContractParamTemplates = createSelector(
    selectContractEditFeature,
    feature => (feature?.contractParamTemplates),
)
export const selectContractEditDrupozs = createSelector(
    selectContractEditFeature,
    feature => (feature?.drupozs),
)
export const selectContractEditZpvypos = createSelector(
    selectContractEditFeature,
    feature => (feature?.zpvypos),
)
export const selectContractEditRunningTask = createSelector(
    selectContractEditFeature,
    feature => feature?.runningTask,
)
export const selectContractEditPreviousOwnersCount = createSelector(
    selectContractEditFeature,
    feature => (feature?.previousOwnersCount),
)
export const selectContractEditIndividual = createSelector(
    selectContractEditFeature,
    feature => (feature?.individual),
)
export const selectContractEditFirstPossibleTerminationDate = createSelector(
    selectContractEditFeature,
    feature => (feature?.firstPossibleTerminationDate),
)
export const selectContractEditAttachments = createSelector(
    selectContractEditFeature,
    feature => (feature?.attachments),
)
export const selectContractEditAttachmentsLoading = createSelector(
    selectContractEditFeature,
    feature => (feature?.attachmentsLoading),
)
export const selectContractEditRelatedContracts = createSelector(
    selectContractEditFeature,
    feature => (feature?.relatedContracts),
)
// ==>
export const selectContractEditLvInfo = createSelector(
    selectContractEditParcels,
    selectContractEditSameLVAndKatuze,
    (parcels, sameLVAndKatuze) => {
        if (sameLVAndKatuze && parcels?.length) {
            return parcels[0].katuzeNazev + ', LV ' + parcels[0].lv
        } else {
            return null
        }
    }
)

export const selectContractEditContractAndSignatureYear = createSelector(
    selectContractEditContract,
    selectContractEditSignatureYear,
    (contract, signatureYear) => ({ contract, signatureYear }),
)

export const selectContractEditAddParcelsData = createSelector(
    selectContractEditFeature,
    selectContractEditContractCpds,
    selectContractEditContractId,
    (feature, cpds, contractId) => ({ parcels: feature?.parcels, cpds, contractId }),
)
export const selectComputeContractPriceAndTaxData = createSelector(
    selectContractEditContractId,
    selectContractEditContractOwnerIds,
    selectContractEditParcels,
    selectContractEditIsLoading,
    selectContractEditContractRentDrupozCollection,
    selectContractEditContractRentUnknownCollection,
    selectContractEditContractRentType,
    (contractId, ownerIds, parcels, isLoading, contractRentDrupozCollection, contractRentUnknownCollection, rentType): {
        contractId: number;
        isAnyOwnerIds: boolean;
        isAnyParcels: boolean;
        isLoading: boolean;
        contractRentDrupozCollection: any;
        contractRentUnknownCollection: any;
        rentType: string;
    } => ({
        contractId,
        isAnyOwnerIds: ownerIds?.length > 0,
        isAnyParcels: parcels?.length > 0,
        isLoading,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
        rentType,
    }),
)
export const selectContractEditEditedCpdAndConsequencies = createSelector(
    selectContractEditEditedCpd,
    selectContractEditContractCpds,
    selectContractEditEditedParcel,
    selectContractEditParcels,
    (editedCPD, cpds, editedParcel, parcels) => ({ editedCPD, cpds, editedParcel, parcels }),
)

export const selectContractEditContractWithSubjects = createSelector(
    selectContractEditContract,
    selectContractEditOwners,
    selectContractEditTenants,
    selectContractEditSelectedContractTemplate,
    (contract, owners, tenants, selectedContractTemplate) => ({
        contract,
        owners,
        tenants,
        selectedContractTemplate,
    }),
)
export const selectContractEditParcelDelete = createSelector(
    selectContractEditParcels,
    selectContractEditEditedParcel,
    selectContractEditEditedCpd,
    selectContractEditContractCpds,
    (parcels, editedParcel, editedCpd, cpds) => ({
        parcels,
        editedParcel,
        editedCpd,
        cpds,
    }),
)
export const selectContractEditSetContract = createSelector(
    selectContractEditContractIndefinite,
    selectContractEditIsAppendix,
    selectContractEditContractAppendixSourceId,
    selectContractEditIsSuccessive,
    selectContractEditContractSuccessiveSourceId,
    selectContractEditParamTemplates,
    selectContractEditSelectedContractTemplate,
    (indefinite, isAppendix, appendixSourceId, isSuccessive, successiveSourceId, contractParamTemplates, selectedContractTemplate) => ({
        indefinite,
        isAppendix,
        appendixSourceId,
        isSuccessive,
        successiveSourceId,
        contractParamTemplates,
        selectedContractTemplate,
    }),
)

export const selectSetContractParcelRentData = createSelector(
    selectContractEditEditedCpd,
    selectContractEditEditedParcel,
    selectContractEditContract,
    selectContractEditContractRentDrupozCollection,
    selectContractEditContractRentUnknownCollection,
    (editedCPD, editedParcel, contract, contractRentDrupozCollection, contractRentUnknownCollection) => ({
        editedCPD,
        editedParcel,
        contract,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
    }),
)

export const selectContractParamTemplates = createSelector(
    selectContractEditSelectedContractTemplate,
    selectContractEditContractContractParamTemplate,
    selectContractEditContractParamTemplate,
    (selectedContractTemplate, contractParamTemplate, paramTemplate) => ({
        selectedContractTemplate,
        contractParamTemplate,
        paramTemplate,
    }),
)

export const selectContractEditParcelsAndCpds = createSelector(
    selectContractEditParcels,
    selectContractEditContractCpds,
    (parcels, cpds) => ({
        parcels,
        cpds,
    }),
)

export const selectContractEditBeforeSetOwners = createSelector(
    selectContractEditTenants,
    selectContractEditContractOwnerParams,
    (tenants, ownerparams) => ({
        tenants,
        ownerparams,
    }),
)

export const selectContractEditPrepareSetParcels = createSelector(
    selectContractEditOwners,
    selectContractEditDrupozs,
    selectContractEditZpvypos,
    (owners, drupozs, zpvypos) => ({
        owners,
        drupozs,
        zpvypos,
    }),
)

export const selectContractEditIds = createSelector(
    selectContractEditContractOwnerIds,
    selectContractEditContractTenantIds,
    selectContractEditContractParcelIds,
    (ownerIds, tenantIds, parcelIds) => ({
        ownerIds,
        tenantIds,
        parcelIds,
    }),
)
// ==>
export const selectContractEditAttachmentsState = createSelector(
    selectContractEditAttachments,
    selectContractEditAttachmentsLoading,
    (attachments, attachmentsLoading) => ({ attachments, attachmentsLoading }),
)
export const selectContractEditDocumentsState = createSelector(
    selectContractEditRelatedContracts,
    selectContractEditSignatureDocuments,
    selectContractEditSignatureDocumentsGroup,
    selectContractEditOwners,
    selectContractEditContractId,
    selectContractEditPayoutToId,
    selectContractEditGroupId,
    selectContractEditContractCreateIndividualDocuments,
    selectContractEditIsEdit,
    selectContractEditAttachments,
    selectContractEditAttachmentsLoading,
    (relatedContracts, signatureDocuments, signatureDocumentsGroup, owners, contractId, payoutToId, groupId, createIndividualDocuments, canAddDocuments, attachments, attachmentsLoading) => ({
        relatedContracts,
        signatureDocuments,
        signatureDocumentsGroup,
        owners,
        contractId,
        payoutToId,
        groupId,
        createIndividualDocuments,
        canAddDocuments,
        attachments,
        attachmentsLoading,
    }),
)
// ==>
export const selectContractEditBooleans = createSelector(
    selectContractEditIsLoading,
    selectContractEditIsEdit,
    selectContractEditIsAppendix,
    selectContractEditIsSuccessive,
    selectContractEditIsRentTypeDefined,
    selectContractEditIsEditingContract,
    selectContractEditSameLVAndKatuze,
    (isLoading, isEdit, isAppendix, isSuccessive, isRentTypeDefined, isEditingContract, sameLVAndKatuze) => ({
        isLoading,
        isEdit,
        isAppendix,
        isSuccessive,
        isRentTypeDefined,
        isEditingContract,
        sameLVAndKatuze,
    }),
)
export const selectContractEditEditedObjects = createSelector(
    selectContractEditEditedCpd,
    selectContractEditEditedOwnerships,
    selectContractEditEditedParcel,
    (editedCPD, editedOwnerships, editedParcel) => ({
        editedCPD,
        editedOwnerships,
        editedParcel,
    }),
)
export const selectContractEditObjects = createSelector(
    selectContractEditSuccessiveSubjects,
    selectContractEditParcels,
    selectContractEditOwners,
    selectContractEditTenants,
    selectContractEditContractParamTemplates,
    selectContractEditContractRentDrupozCollection,
    selectContractEditContractRentUnknownCollection,
    selectContractEditDrupozs,
    (successiveSubjects, parcels, owners, tenants, contractParamTemplates, contractRentDrupozCollection, contractRentUnknownCollection, drupozs) => ({
        successiveSubjects,
        parcels,
        owners,
        tenants,
        contractParamTemplates,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
        drupozs,
    }),
)
export const selectContractEditData = createSelector(
    selectContractEditFirstPossibleTerminationDate,
    selectContractEditIndividual,
    selectContractEditPreviousOwnersCount,
    selectContractEditRunningTask,
    selectContractEdiSelectedTab,
    selectContractEditSelectedContractTemplate,
    selectContractEditSignatureYear,
    selectContractEditTotalAcreage,
    selectContractEditParcelsOrder,
    (firstPossibleTerminationDate, individual, previousOwnersCount, runningTask, selectedTab, selectedContractTemplate, signatureYear, totalAcreage, parcelsOrder) => ({
        firstPossibleTerminationDate,
        individual,
        previousOwnersCount,
        runningTask,
        selectedTab,
        selectedContractTemplate,
        signatureYear,
        totalAcreage,
        parcelsOrder,
    }),
)
// ==>
export const selectContractEditAddToAttachment = createSelector(
    selectContractEditContract,
    selectContractEditOwners,
    selectContractEditIndividual,
    (contract, owners, individual) => ({
        contract,
        owners,
        individualDocumentNote: individual?.documentNote,
        documentNote: contract?.documentNote,
    }),
)
// ==>
export const selectContractEditWatch = createSelector(
    selectContractEditContract,
    (contract) => ({
        isWatched: contract?.isWatched,
        watchReason: contract?.watchReason,
    }),
)
// ==>
export const selectContractEditTaxTenant = createSelector(
    selectContractEditDrupozs,
    selectContractEditEditedParcel,
    selectContractEditEditedCpd,
    (drupozs, editedParcel, editedCpd) => ({
        drupozs,
        editedParcel,
        editedCpd,
    }),
)

// ==>
export const selectParcelRentedAcreage = createSelector(
    selectContractEditEditedParcel,
    selectContractEditTenants,
    selectContractEditEditedCpd,
    (editedParcel, tenants, editedCpd) => ({
        editedParcel,
        tenants,
        editedCpd,
    }),
)
// ==>
export const selectContractEditTemplates = createSelector(
    selectContractEditContractContractParamTemplate,
    selectContractEditParamTemplates,
    selectContractEditIsLoading,
    (contractParamTemplate, contractParamTemplates, contractIsLoading) => ({
        contractParamTemplate,
        contractParamTemplates,
        contractIsLoading,
    }),
)
// ==> DurationPeriodComponent
export const selectContractShowDurationPeriodState = createSelector(
    selectContractEditContract,
    (contract) => ({
        indefinite: contract?.indefinite,
        reusedPreviousExpiration: contract?.reusedPreviousExpiration,
        durationMonths: contract?.durationMonths,
        durationMonthsUnit: contract?.durationMonthsUnit,
        durationToDate: contract?.durationToDate,
    })
)
// ==>
export const selectContractOptionalParagraph = createSelector(
    selectContractEditContractFurtherRentPossible,
    selectContractEditContractReqNewAppendixAfterReprice,
    selectContractEditContractTenantHasPreemption,
    (furtherRentPossible, reqNewAppendixAfterReprice, tenantHasPreemption) => ({
        furtherRentPossible,
        reqNewAppendixAfterReprice,
        tenantHasPreemption,
    }),
)
// ==> DurationPeriodComponent
export const selectContractEditDurationPeriodState = createSelector(
    selectContractEditContract,
    (contract) => ({
        indefinite: contract?.indefinite,
        reusedPreviousExpiration: contract?.reusedPreviousExpiration,
        durationMonths: toDisplayUnits(contract?.durationMonths, contract?.durationMonthsUnit),
        durationMonthsUnit: contract?.durationMonthsUnit,
        durationToDate: contract?.durationToDate,
    })
)
// notice-period
export const selectContractEditContractNoticePeriod = createSelector(
    selectContractEditContract,
    (contract) => ({
        noticePeriodMonths: toDisplayUnits(contract?.noticePeriodMonths, contract?.noticePeriodMonthsUnit),
        noticePeriodMonthsUnit: contract?.noticePeriodMonthsUnit,
        indefinite: contract?.indefinite,
    })
)
export const selectContractEditContractParcelPrice = createSelector(
    selectContractEditContract,
    selectContractEditEditedCpd,
    selectContractEditEditedParcel,
    (contract, editedCPD, editedParcel) => ({
        contract, editedCPD, editedParcel,
    }),
)

export const selectContractEditOwnersOwnerparams = createSelector(
    selectContractEditOwners,
    selectContractEditContractOwnerParams,
    (owners, ownerparams) => ({
        owners, ownerparams,
    }),
)